// In src/pages/ContactUsPage.js

import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { db } from '../services/firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { Container, Typography, Box, Paper, TextField, Button, Select, MenuItem, FormControl, InputLabel, CircularProgress, Alert } from '@mui/material';

function ContactUsPage() {
  const { currentUser, userProfile } = useAuth();
  const [inquiryType, setInquiryType] = useState('general');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) {
      setError('Please enter a message.');
      return;
    }

    setSubmitting(true);
    setError('');
    setSuccess('');

    try {
      // The path is correctly pointing to the church-specific subcollection
      const inquiriesRef = collection(db, 'churches', userProfile.churchId, 'inquiries');
      
      await addDoc(inquiriesRef, {
        type: inquiryType,
        message: message,
        submittedByUid: currentUser.uid,
        submittedByName: `${userProfile.firstName} ${userProfile.lastName}`,
        submittedByEmail: currentUser.email,
        status: 'new',
        createdAt: serverTimestamp(),
        churchId: userProfile.churchId, // ***** THIS IS THE NEWLY ADDED LINE *****
      });

      setSuccess('Your message has been sent successfully. A member of our team will get back to you shortly.');
      setMessage('');
      setInquiryType('general');
    } catch (err) {
      console.error("Error submitting inquiry:", err);
      setError('There was an error sending your message. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container maxWidth="md">
      <Paper sx={{ p: { xs: 2, md: 4 }, mt: 3 }}>
        <Typography variant="h4" gutterBottom>Contact Us</Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Have a question or a need? Please select a category and send us a message.
        </Typography>

        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Box component="form" onSubmit={handleSubmit}>
          <FormControl fullWidth margin="normal">
            <InputLabel id="inquiry-type-label">Inquiry Type</InputLabel>
            <Select
              labelId="inquiry-type-label"
              value={inquiryType}
              label="Inquiry Type"
              onChange={(e) => setInquiryType(e.target.value)}
            >
              <MenuItem value="general">General Question</MenuItem>
              <MenuItem value="pastor">Contact a Pastor</MenuItem>
              <MenuItem value="maintenance">Building Maintenance Request</MenuItem>
              <MenuItem value="prayer">Prayer Request</MenuItem>
            </Select>
          </FormControl>

          <TextField
            margin="normal"
            fullWidth
            required
            multiline
            rows={6}
            label="Your Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />

          <Button
            type="submit"
            variant="contained"
            size="large"
            disabled={submitting}
            sx={{ mt: 2 }}
          >
            {submitting ? <CircularProgress size={24} /> : 'Send Message'}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}

export default ContactUsPage;